import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ConfigLinksDetailsContext } from '../../Context/cofingLinksDetailsContext';

const SEO = ({ title, description, keywords = [] }) => {
  const { t, i18n } = useTranslation();
  const { configLinks } = useContext(ConfigLinksDetailsContext);
  
  const municipalityNameAr = configLinks?.municipalityNameAr || "البلدية";
  const municipalityNameEn = configLinks?.municipalityNameEn || "Municipality";
  
  const currentLang = i18n.language;
  const municipalityName = currentLang === 'ar' ? municipalityNameAr : municipalityNameEn;
  const appName = currentLang === 'ar' ? 'الخدمات الإلكترونية' : 'E-Services';
  
  const defaultTitle = `${municipalityName} - ${appName}`;
  const pageTitle = title ? `${title} | ${municipalityName}` : defaultTitle;
  
  const defaultDescription = currentLang === 'ar' 
    ? `البوابة الإلكترونية ل${municipalityNameAr} - تقديم طلبات، استعلامات، وخدمات إلكترونية للمواطنين.`
    : `E-Services Portal for ${municipalityNameEn} - Submit requests, inquiries, and online services for citizens.`;
    
  const metaDescription = description || defaultDescription;
  
  // Generate keywords from municipality names
  const nameKeywordsAr = municipalityNameAr.split(' ').filter(w => w.length > 2);
  const nameKeywordsEn = municipalityNameEn.split(' ').filter(w => w.length > 2);
  
  const defaultKeywords = [
    "بلدية", "خدمات", "الكترونية", "فلسطين", "Municipality", "Services", "E-Services", "Palestine",
    ...nameKeywordsAr,
    ...nameKeywordsEn,
    municipalityNameAr,
    municipalityNameEn
  ];
  
  // Remove duplicates
  const uniqueKeywords = [...new Set([...defaultKeywords, ...keywords])];
  const metaKeywords = uniqueKeywords.join(', ');

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:site_name" content={municipalityName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={metaDescription} />
    </Helmet>
  );
};

export default SEO;
